import { render, staticRenderFns } from "./EmployeeCourseVideos.vue?vue&type=template&id=519572d1&scoped=true"
import script from "./EmployeeCourseVideos.vue?vue&type=script&lang=js"
export * from "./EmployeeCourseVideos.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCourseVideos.vue?vue&type=style&index=0&id=519572d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519572d1",
  null
  
)

export default component.exports